import ImagePickerButtons from './ImagePickerButtons';
import { DEFAULT_GENERIC_RESULT_OPTIONS, getAllowedResultOptions } from '../utils/resultOptions';
import { storageUrl } from '../utils/urls';

export default function InspectionItemRow({ item, value, onChange, onUpload, onRemoveImage, resultOptions = DEFAULT_GENERIC_RESULT_OPTIONS }) {
  const allowed = Array.isArray(item?.allowed_result_types) && item.allowed_result_types.length
    ? item.allowed_result_types
    : resultOptions.map((option) => option.value);

  const options = getAllowedResultOptions(resultOptions, allowed);

  // الضغط على النتيجة المختارة يلغيها: إلغاء التحديد يعني ألا نتيجة للبند،
  // لا أن يتحول تلقائيًا إلى «جيد».
  const toggleResult = (optionValue) => {
    const isSelected = value?.condition_type === optionValue;
    onChange(item.id, { condition_type: isSelected ? '' : optionValue });
  };

  return (
    <div className="rounded-xl border p-3 bg-white shadow-sm">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <h4 className="font-bold text-gray-800">{item.name}</h4>
        <div className="flex gap-2 flex-wrap">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              aria-pressed={value?.condition_type === option.value}
              onClick={() => toggleResult(option.value)}
              className={`px-3 py-1 rounded-lg text-sm border transition ${
                value?.condition_type === option.value ? 'ring-2 ring-offset-1 ring-gray-900' : 'opacity-70 hover:opacity-100'
              }`}
              style={{
                backgroundColor: option.bgColor,
                borderColor: option.borderColor,
                color: option.textColor,
              }}
            >
              {value?.condition_type === option.value ? '✔ ' : ''}
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-3 grid gap-2 md:grid-cols-[1fr_auto_auto] md:items-center">
        <input
          type="text"
          value={value?.notes || ''}
          placeholder="ملاحظة..."
          onChange={(e) => onChange(item.id, { notes: e.target.value })}
          className="w-full rounded-lg border p-2"
        />
        {value?.attachment?.file_path && (
          <div className="relative h-14 w-14 overflow-hidden rounded-lg border bg-slate-100">
            <img src={storageUrl(value.attachment.file_path)} alt="" className="h-full w-full object-cover" />
            <button
              type="button"
              onClick={() => onRemoveImage?.(item.id, value.attachment)}
              className="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/70 text-xs font-bold leading-none text-white"
              aria-label="Remove image"
            >
              ×
            </button>
          </div>
        )}
        <ImagePickerButtons onSelect={(file) => onUpload(item.id, file)} />
      </div>
    </div>
  );
}
